import React from 'react';
import { CookiesProvider } from 'react-cookie';

export const withQuestions = function(WrappedComponent) {
  const Wrapper = props =>
    <CookiesProvider>
      <WrappedComponent {...props} />
    </CookiesProvider>;
  return Wrapper;
}; 